<template>
  <q-btn
      v-if="isGranted('ADD_CLIENT')"
      icon="fa fa-plus"
      v-bind="$attrs"
      @click="openModal"/>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import isGranted from '@/auth/isGranted';
import { AccountContextMixin } from '@/mixins';
import { Client } from '@/type';
import openModal from '@/components/modal';
import AddClientModal from './AddClientModal.vue';

export default defineComponent({
  emits: ['added'],
  mixins: [AccountContextMixin, AccountContextMixin],
  props: {
    star: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    openModal() {
      const config = {
        parent: this,
        customerId: this.accountId,
        star: this.star,
      };
      openModal(AddClientModal, config)
        .onOk((client: Client) => {
          this.$emit('added', client);
        });
    },
    isGranted,
  },
});
</script>
